import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../DMSHeader/DMSHeader";
import { useTranslation } from "react-i18next";
import AllBranchesList from "./AllBranchesList";

// Component for rendering Branch table data
const AllBranches = () => {
  // Hook for internationalization/translation support
  const { t } = useTranslation();

  // Initialize GridStack on component mount
  useEffect(() => {
    GridStack.init();
  }, []);

  // Layout configuration for grid items with header and branches list
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      // Header component with title, download and menu options
      component: (
        <DMSHeader
          title={t("all_branches")}
          fileName="All Branches"
          showmenu={true}
          showdownload={true}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      // Main content component displaying the branches list
      component: <AllBranchesList />,
    },
  ];

  // Render grid container with configured layout items
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default AllBranches;
